import { render } from "./BookListTable.vue?vue&type=template&id=13a7bc84&scoped=true"
import script from "./BookListTable.vue?vue&type=script&lang=js"
export * from "./BookListTable.vue?vue&type=script&lang=js"

import "./BookListTable.vue?vue&type=style&index=0&id=13a7bc84&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a7bc84"]])

export default __exports__